import { useLanguage } from './LanguageContext';

type TranslationKey = string;

export function useTranslations(namespace?: TranslationKey) {
  const { translate } = useLanguage();
  
  return (key: string, params?: Record<string, string | number>) => {
    const fullKey = namespace ? `${namespace}.${key}` : key;
    let translation = translate(fullKey);

    // Handle parameter interpolation
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        translation = translation.replace(`{${key}}`, String(value));
      });
    }

    return translation;
  };
}

// Helper hook for global translations
export function useGlobalTranslations() {
  return useTranslations();
}
